export default class activeMenu {
  constructor() {
    let url = window.location.pathname.replace(/^\/+/, '')
    const links = document.querySelectorAll('.js-menu-items a')
    links.forEach((link) => {
      link.classList.remove('is-active')
      let linkHref = link.dataset['slug']
      if (url === '' && linkHref === 'home') {
        link.classList.add('is-active')
      }
      if (url === linkHref) {
        link.classList.add('is-active')
      }
    })
  }
}
